module.exports = __webpack_public_path__ + "static/media/vjt.c54faf17.png";